import {Injectable} from '@angular/core';
import {FgiBackEndService} from '../../shared/fgi-back-end.service';
import {Observable} from 'rxjs';
import {blockUi} from '@bndes/bndes-ux4/bndes-angular-utils';
import {catchError} from 'rxjs/operators';
import { ModalidadeScrModel } from 'src/app/model/modalidade-scr.model';

@Injectable({
  providedIn: 'root'
})
export class ModalidadeScrService extends FgiBackEndService<any> {

  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return 'front/scr';
  }

  public listarTodosFiltrados(params?: any): Observable<any> {
    const options: any = blockUi();
    options.params = params;
    return this.http.get(`${this.BASE_URL}/busca-filtrados`, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public listarHabilitados(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/busca-habilitados`).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public listarNaoHabilitados(): Observable<any> {
    return this.http.get(`${this.BASE_URL}/nao-habilitados`).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public habilitar(dto: any): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/habilitar`, dto, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public salvar(dto: any): Observable<any> {
      const options: any = blockUi();
      return this.http.post(`${this.BASE_URL}/`, dto, options).pipe
        (catchError((e) => this.handleError(e))) as Observable<any>;
    }

  public desabilitar(codigo: number): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${codigo}/desabilitar`, {}, options).pipe
    (catchError((e) => this.handleError(e))) as Observable<any>;
  }
}
